export default class HelperTable {

    static createRowHeader(columns) {
        const thead = document.createElement('thead');
        const tr = HelperTable.createRow(columns, 'label', 'th');
        thead.appendChild(tr);
        return thead;
    }

    static createRowFooterEmpty(columns) {
        const thead = document.createElement('tfoot');
        const tr = HelperTable.createRow(columns, '', 'td');
        thead.appendChild(tr);
        return thead;
    }

    static createRow(columns, value = 'value', tag = 'td') {
        const tr = document.createElement('tr');

        columns.forEach(item => {
            const cell = document.createElement(tag);
            cell.innerHTML = item?.[value] || ''; // Using optional chaining
            tr.appendChild(cell); // Append cell to the row
        });

        return tr;
    }

    static getButtonToggleCoefficient() {
        const btn = document.createElement('span');
        btn.classList = 'btn-coef';
        btn.textContent = '';
        return btn;
    }

    static createToolbarButtons(props) {
        const toolbar = $(`<div class="toolbar"></div>`)
        const buttons = $(`<div class="buttons flex gap-2"></div>`)

        if (props?.btnAdd) {
            buttons.append($(`<button class=" btn-row-add btn btn-sm btn-primary"><span>&#65291; ${ESR.lang.add}</span></button>`))
        }

        if (props?.btnEdit) {
            buttons.append($(`<button class="btn-row-edit btn btn-sm btn-primary btn-disabled"><span>${ESR.lang.edit}</span></button>`))
        }

        if (props?.btnDelete) {
            buttons.append($(`<button class="btn-row-remove btn btn-sm btn-primary btn-disabled"><span>${ESR.lang.delete}</button>`))
        }

        toolbar.append(buttons)

        return toolbar;
    }

    static onSelectRow(e, table, btnRowEdit, btnRowRemove, btnResetPassword = null) {
        // Find the clicked table row (tr), ensuring it exists
        const tr = e.target.tagName === 'TR' ? e.target : e.target.closest('tr');

        if(e.target.tagName === 'TD' && e.target.classList.contains('dt-control')) {
            return;
        }

        if (tr?.parentNode?.tagName !== 'TBODY') {
            return;
        }

        // If no table row was found, return early
        // Check if the row is a 'group' row
        if (tr.classList.contains('group')) {
            // Remove 'selected' class from any selected rows
            // table.rows('.selected').nodes().each(row => row.classList.remove('selected'));
            // // Disable buttons for group rows
            // btnRowEdit?.addClass('btn-disabled');
            // btnRowRemove?.addClass('btn-disabled');
            return;
        }

        // If the row is already selected, deselect it
        if (tr.classList.contains('selected')) {
            tr.classList.remove('selected');
            btnRowEdit?.addClass('btn-disabled');
            btnRowRemove?.addClass('btn-disabled');
            btnResetPassword?.addClass('btn-disabled');
        } else {
            table.rows('.selected').nodes().each(row => row.classList.remove('selected'));
            tr.classList.add('selected');
            btnRowEdit?.removeClass('btn-disabled');
            btnRowRemove?.removeClass('btn-disabled');
            btnResetPassword?.removeClass('btn-disabled');
        }
    }

    static renderColumnTermName = (data, type, row) => {
        if (type === 'display') {
            return row.term_name;
        } else if (type === 'filter') {
            return row.term_id + ' ' + row.term_name;
        }

        return data;
    }

    static btnColvis() {
        return {
            extend: 'colvis',
            text: ESR.lang.columns,
            className: 'btn btn-sm btn-neutral',
        }
    }

    static btnDownloads(title = '') {

        const exportTitle = title || '';

        const exportOptions = {
            modifier: { selected: null }, // all pages
            columns: ':visible:not(.no-export)'
        };

        return {
            extend: 'collection',
            text: ESR?.lang?.export || 'Export',
            className: 'btn-export btn btn-sm btn-neutral',
            buttons: [
                {
                    extend: 'excelHtml5',
                    title: exportTitle,
                    exportOptions
                },
                {
                    extend: 'pdfHtml5',
                    title: exportTitle,
                    text: 'PDF',
                    exportOptions
                },
                {
                    extend: 'print',
                    title: exportTitle,
                    text: ESR?.lang?.print || 'Print',
                    exportOptions
                }
            ]
        };
    }

    static createButton(text, className, callback) {
        return {
            text: text,
            className: className,
            action: function (e, dt, el, config) {
                if (typeof callback === 'function') {
                    callback(e, dt, el, config);
                } else {
                    console.log(`No action provided for ${className}`);
                }
            }
        };
    }

    static btnAdd(callback) {
        return this.createButton('&#65291; ' + ESR.lang.add, 'btn btn-sm btn-primary btn-row-add', callback);
    }

    static btnEdit(callback) {
        return this.createButton(ESR.lang.edit, 'btn btn-sm btn-primary btn-row-edit btn-disabled', callback);
    }

    static btnRemove(callback) {
        return this.createButton(ESR.lang.delete, 'btn btn-sm btn-primary btn-row-remove btn-disabled', callback);
    }

    static serializeUniqueOptions(data, idKey, labelKey, itemKey = null, sortBy = 'label') {
        const uniqueItems = {};

        data.forEach(item => {
            const entries = itemKey ? item[itemKey] : [item];
            entries.forEach(entry => {
                const id = entry[idKey];
                const label = entry[labelKey] || `id ${id}`;
                if (!uniqueItems.hasOwnProperty(id)) {
                    uniqueItems[id] = {
                        value: id,
                        label: label
                    };
                }
            });
        });

        const uniqueArray = Object.values(uniqueItems);

        // Sort by either 'value' or 'label'
        uniqueArray.sort((a, b) => {
            if (sortBy === 'value') {
                return a.value - b.value; // Sort by numeric value
            } else {
                return a.label.localeCompare(b.label); // Default to sorting by label
            }
        });

        return uniqueArray;
    }

    static serializeTableDataWorkersOptions(data) {
        return this.serializeUniqueOptions(data, 'id', 'name', 'manager');
    }

    static serializeChapterOptions(data) {
        return this.serializeUniqueOptions(data, 'term_id', 'term_name');
    }

    static serializeWorkersOptions(data) {
        return this.serializeUniqueOptions(data, 'id', 'name', 'workers');
    }

    static serializeTableDataManagersOptions(data) {
        return this.serializeUniqueOptions(data, 'id', 'name', 'manager');
    }

    static createColumnSelectOptions(column, objValue = '', objLabel = '') {
        const columnData = column.data()
        let options = [];

        if (columnData[0] === null) {
            return options;
        }

        if (typeof columnData[0] !== 'object') {

            columnData.unique().sort().each(function (d, j) {
                options.push({value: d, label: d})
            });

            return options;
        }

        let uniqueManagers = []

        columnData.each(function (d, j) {
            if (!uniqueManagers.hasOwnProperty(d[objValue])) {
                uniqueManagers[d[objValue]] = d[objLabel];
            }
        });

        // Convert the object to an array of entries and sort it
        let sortedManagers = Object.entries(uniqueManagers).sort((a, b) => {
            return a[1].localeCompare(b[1]);
        });

        sortedManagers.forEach(function ([value, label]) {
            options.push({value, label})
        });

        return options;
    }

    static getServicesTableData(){
        return Object.entries(ESR.services).map(item => {
            const term = ESR.services_terms[item[1].term_id]
            return {
                ...item[1],
                term_name: term.term_name
            };
        })
    }
}
